import type { DebugParseImageResponse } from '@mrrmlab/api-client';

let _result: DebugParseImageResponse | null = null;

export const ocrAnalyzeStore = {
  set: (result: DebugParseImageResponse) => { _result = result; },
  consume: (): DebugParseImageResponse | null => { const v = _result; _result = null; return v; },
};
